import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {CurrentUserApiService} from '../../data/api/service';
import {logError} from '../error-handling/error-handling.actions';
import * as currentUserActions from './current-user.actions';

@Injectable()
export class CurrentUserEffects {
  loadCurrentUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(currentUserActions.loadCurrentUser),
      switchMap(() =>
        this.currentUserApi.getCurrentUser().pipe(
          map(response =>
            currentUserActions.loadCurrentUserSuccess({
              user: response.result.user,
            }),
          ),
          catchError(error =>
            of(
              currentUserActions.loadCurrentUserFailure({
                error: {
                  error,
                  message: 'There was a problem loading the current user.',
                },
              }),
            ),
          ),
        ),
      ),
    );
  });

  loadCurrentUserFailure$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(currentUserActions.loadCurrentUserFailure),
      map(logError),
    );
  });

  constructor(
    private actions$: Actions,
    private currentUserApi: CurrentUserApiService,
  ) {}
}
